import type {
  TranslationData,
  UpdateLangRequest,
} from '../../services/translations/langManager';

const extractTagsFromText = (
  text: string
): { cleaned: string; tags: string[] } => {
  const tagRegex = /\[([^\]]+)\]/g;
  const tags: string[] = [];
  let match: RegExpExecArray | null;

  while ((match = tagRegex.exec(text)) !== null) {
    tags.push(match[0]);
  }

  let cleaned = text;
  tags.forEach((tag, index) => {
    cleaned = cleaned.replace(tag, `__TAG_${index}__`);
  });

  return { cleaned, tags };
};

const restoreTagsInText = (text: string, tags: string[]): string => {
  let result = text;
  tags.forEach((tag, index) => {
    result = result.replace(`__TAG_${index}__`, tag);
  });
  return result;
};

export const extractAllTags = (
  texts: TranslationData
): {
  cleanedTexts: TranslationData;
  tagsMap: Record<string, string[]>;
} => {
  const cleanedTexts: TranslationData = {};
  const tagsMap: Record<string, string[]> = {};

  Object.entries(texts).forEach(([key, value]) => {
    const { cleaned, tags } = extractTagsFromText(
      typeof value === 'string' ? value : String(value)
    );
    cleanedTexts[key] = cleaned;
    tagsMap[key] = tags;
  });

  return { cleanedTexts, tagsMap };
};

export const restoreAllTags = (
  translations: Record<string, Record<string, string>>,
  tagsMap: Record<string, string[]>
): UpdateLangRequest => {
  const restored: Partial<UpdateLangRequest> = {};

  Object.entries(translations).forEach(([lang, texts]) => {
    const restoredTexts: TranslationData = {};
    Object.entries(texts).forEach(([key, value]) => {
      const tags = tagsMap[key] ?? [];
      restoredTexts[key] = restoreTagsInText(
        typeof value === 'string' ? value : String(value),
        tags
      );
    });
    restored[lang as keyof UpdateLangRequest] = restoredTexts;
  });

  return restored as UpdateLangRequest;
};
